"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var QRCode = __importStar(require("./qrCode"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var material_1 = require("@mui/material");
// created for AR Runway, places a QR code inside a blank space in an image
var Component = function (p) { return (Preact.h(Box_1.default, { sx: { mb: 4 }, position: "relative" },
    Preact.h("img", { src: p.imageSrc, style: { width: '100%', height: '424px', borderRadius: '8px', objectFit: 'cover' } }),
    Preact.h(Box_1.default, { alignItems: "center", display: "flex", flexDirection: "column", position: "absolute", top: "110px", right: "65px", bgcolor: "background.default" },
        Preact.h(QRCode.Component, { url: p.url, size: 130 }),
        Preact.h(material_1.Typography, { variant: "h5", paddingTop: "5px" }, p.qrHintText)))); };
exports.Component = Component;
